/** @format */

import { HeaderCheckBoxSelectListElement } from '../views/lib/search/listTableHeader/HeaderCheckBoxSelectList';

/** @fromat */

export const certificationRequestInt = {
    EXPIRED: -4,
    REJECTED: -3,
    DISCARDED: -2,
    ERROR: -1,
    NEW: 0,
    SELECTED_FOR_PROCESSING: 1,
    ADMIN_MAIL_SENT: 2,
    ACCEPTED: 3,
    AWAITING_CERTIFICATE: 4,
    MAIL_SENT: 5,
    PROCESSED: 1000,
    DOWNLOADED: 2000,
};

export const certificationRequestI18n = {
    EXPIRED: 'auth:certificate_states.expired',
    REJECTED: 'auth:certificate_states.rejected',
    DISCARDED: 'auth:certificate_states.discarded',
    ERROR: 'auth:certificate_states.error',
    NEW: 'auth:certificate_states.new',
    SELECTED_FOR_PROCESSING: 'auth:certificate_states.selected_for_processing',
    ADMIN_MAIL_SENT: 'auth:certificate_states.admin_mail_sent',
    ACCEPTED: 'auth:certificate_states.accepted',
    AWAITING_CERTIFICATE: 'auth:certificate_states.awaiting_certificate',
    MAIL_SENT: 'auth:certificate_states.mail_sent',
    PROCESSED: 'auth:certificate_states.processed',
    DOWNLOADED: 'auth:certificate_states.downloaded',
};

export class CertificationRequestState {
    getStatusList = (): Array<HeaderCheckBoxSelectListElement> => {
        return [
            { value: certificationRequestInt.EXPIRED, name: certificationRequestI18n.EXPIRED },
            { value: certificationRequestInt.REJECTED, name: certificationRequestI18n.REJECTED },
            { value: certificationRequestInt.DISCARDED, name: certificationRequestI18n.DISCARDED },
            { value: certificationRequestInt.ERROR, name: certificationRequestI18n.ERROR },
            { value: certificationRequestInt.NEW, name: certificationRequestI18n.NEW },
            { value: certificationRequestInt.SELECTED_FOR_PROCESSING, name: certificationRequestI18n.SELECTED_FOR_PROCESSING },
            { value: certificationRequestInt.ADMIN_MAIL_SENT, name: certificationRequestI18n.ADMIN_MAIL_SENT },
            { value: certificationRequestInt.ACCEPTED, name: certificationRequestI18n.ACCEPTED },
            { value: certificationRequestInt.AWAITING_CERTIFICATE, name: certificationRequestI18n.AWAITING_CERTIFICATE },
            { value: certificationRequestInt.MAIL_SENT, name: certificationRequestI18n.AWAITING_CERTIFICATE },
            { value: certificationRequestInt.PROCESSED, name: certificationRequestI18n.PROCESSED },
            { value: certificationRequestInt.DOWNLOADED, name: certificationRequestI18n.DOWNLOADED },
        ];
    };

    getI18NForInt = (int: number): string => {
        switch (int) {
            case certificationRequestInt.EXPIRED:
                return certificationRequestI18n.EXPIRED;
            case certificationRequestInt.REJECTED:
                return certificationRequestI18n.REJECTED;
            case certificationRequestInt.DISCARDED:
                return certificationRequestI18n.DISCARDED;
            case certificationRequestInt.ERROR:
                return certificationRequestI18n.ERROR;
            case certificationRequestInt.NEW:
                return certificationRequestI18n.NEW;
            case certificationRequestInt.SELECTED_FOR_PROCESSING:
                return certificationRequestI18n.SELECTED_FOR_PROCESSING;
            case certificationRequestInt.ADMIN_MAIL_SENT:
                return certificationRequestI18n.ADMIN_MAIL_SENT;
            case certificationRequestInt.ACCEPTED:
                return certificationRequestI18n.ACCEPTED;
            case certificationRequestInt.AWAITING_CERTIFICATE:
                return certificationRequestI18n.AWAITING_CERTIFICATE;
            case certificationRequestInt.MAIL_SENT:
                return certificationRequestI18n.AWAITING_CERTIFICATE;
            case certificationRequestInt.PROCESSED:
                return certificationRequestI18n.PROCESSED;
            case certificationRequestInt.DOWNLOADED:
                return certificationRequestI18n.DOWNLOADED;
            default:
                return certificationRequestI18n.ERROR;
        }
    };
}
